import {
  useCallback
} from 'react';

const useAnalytics = () => {
  // Initialize dataLayer
  const getDataLayer = useCallback(() => {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  }, []);

  const trackEvent = useCallback((eventData) => {
    try {
      const dataLayer = getDataLayer();
      dataLayer.push(eventData);
    } catch (error) {
      console.error('Analytics tracking error:', error);
    }
  }, [getDataLayer]);

  // Specific tracking functions
  const trackBoadingPassInitLoad = useCallback((linkText) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/boardingpass/home',
    });
  }, [trackEvent]);

  const trackBoardingPassStart = useCallback((linkText) => {
    trackEvent({
      event: 'boardingpass_start',
    });
  }, [trackEvent]);

  const trackCoreValueLoad = useCallback((platform) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/boardingpass/corevalue',
    });
  }, [trackEvent]);

  const trackCoreValueSelected = useCallback((value) => {
    trackEvent({
      event: 'corevalue_selected',
      core_value: value,
    });
  }, [trackEvent]);

  const trackSpecialtyLoad = useCallback((platform) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/boardingpass/specialty',
    });
  }, [trackEvent]);

  const trackSpecialtySelected = useCallback((value) => {
    trackEvent({
      event: 'specialty_selected',
      specialty: value,
    });

  }, [trackEvent]);

  const trackBackgroundSelectLoad = useCallback((value) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/boardingpass/background',
    });
  }, [trackEvent]);

  const trackBackgroundSelected = useCallback((value) => {
    trackEvent({
      event: 'background_selected',
      background: value,
    });
  }, [trackEvent]);

  const trackBoardingPassRender = useCallback((value) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/boardingpass/pass_rendered',
    });
  }, [trackEvent]);

  const trackBoardingPassMainMenu = useCallback((value) => {
    trackEvent({
      event: 'mainmenu_clicked',
    });
  }, [trackEvent]);

  const trackBoardingPassDownload = useCallback((value) => {
    trackEvent({
      event: 'download_clicked',
    });
  }, [trackEvent]);

  const trackMainMenuClick = useCallback((value) => {
    trackEvent({
      event: 'lvl62_main_menu_clicks',
      section: value
    });
  }, [trackEvent]);

  const trackRailInspectionLoad = useCallback((value) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/rail_inspection/start'
    });
  }, [trackEvent]);

  const trackRailInspectionStart = useCallback((value) => {
    trackEvent({
      event: 'lvl62_game_start',
      game_name: 'rail_inspection'
    });
  }, [trackEvent]);

  const trackRailInspectionLvlOneStart = useCallback((value) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/rail_inspection/level1_start'
    });
  }, [trackEvent]);

  const trackRailInspectionLvlOneFinish = useCallback((value) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/rail_inspection/level1_finish'
    });
  }, [trackEvent]);

  const trackRailInspectionNextLevel = useCallback((value) => {
    trackEvent({
      event: 'lvl62_next_level_click',
      game_name: 'rail_inspection',
      game_level: value
    });
  }, [trackEvent]);

  const trackRailInspectionLvlTwoStart = useCallback((value) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/rail_inspection/level2_start'
    });
  }, [trackEvent]);

  const trackRailInspectionLvlTwoFinish = useCallback((value) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/rail_inspection/level2_finish'
    });
  }, [trackEvent]);

  const trackRailInspectionLvlThreeStart = useCallback((value) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/rail_inspection/level3_start'
    });
  }, [trackEvent]);

  const trackRailInspectionLvlThreeFinish = useCallback((value) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/rail_inspection/level3_finish'
    });
  }, [trackEvent]);

  const trackRailInspectionPlayAgain = useCallback((value) => {
    trackEvent({
      event: 'lvl62_play_again',
      game_name: 'rail_inspection'
    });
  }, [trackEvent]);

  const trackViewFinderLoad = useCallback((value) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/viewfinder/start'
    });
  }, [trackEvent]);

  const trackViewFinderStart = useCallback((value) => {
    trackEvent({
      event: 'lvl62_game_start',
      game_name: 'viewfinder'
    });
  }, [trackEvent]);

  const trackViewFinderLevelOneStart = useCallback((value) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/viewfinder/level1_start'
    });
  }, [trackEvent]);

  const trackViewFinderLevelOneFinish = useCallback((value) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/viewfinder/level1_finish'
    });
  }, [trackEvent]);

  const trackViewfinderNextLevel = useCallback((value) => {
    trackEvent({
      event: 'lvl62_next_level_click',
      game_name: 'viewfinder',
      game_level: value
    });
  }, [trackEvent]);

  const trackViewFinderLevelTwoStart = useCallback((value) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/viewfinder/level2_start'
    });
  }, [trackEvent]);

  const trackViewFinderLevelTwoFinish = useCallback((value) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/viewfinder/level2_finish'
    });
  }, [trackEvent]);

  const trackViewFinderLevelThreeStart = useCallback((value) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/viewfinder/level3_start'
    });
  }, [trackEvent]);

  const trackViewFinderLevelThreeFinish = useCallback((value) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/viewfinder/level3_finish'
    });
  }, [trackEvent]);

  const trackViewFinderPlayAgain = useCallback((value) => {
    trackEvent({
      event: 'lvl62_play_again',
      game_name: 'viewfinder'
    });
  }, [trackEvent]);


  const trackAscendLoad = useCallback((value) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/ascend/start'
    });
  }, [trackEvent]);


  const trackAscendStart = useCallback((value) => {
    trackEvent({
      event: 'lvl62_game_start',
      game_name: 'ascend'
    });
  }, [trackEvent]);


  const trackAscendFinish = useCallback((value) => {
    trackEvent({
      event: 'page_view',
      page_location: 'lvl62.com/asceend/finish'
    });
  }, [trackEvent]);

  const trackAscendPlayAgain = useCallback((value) => {
    trackEvent({
      event: 'lvl62_play_again',
      game_name: 'ascend'
    });
  }, [trackEvent]);

  return {
    trackEvent,
    trackBoadingPassInitLoad,
    trackBoardingPassStart,
    trackCoreValueLoad,
    trackCoreValueSelected,
    trackSpecialtyLoad,
    trackSpecialtySelected,
    trackBackgroundSelectLoad,
    trackBackgroundSelected,
    trackBoardingPassRender,
    trackBoardingPassMainMenu,
    trackBoardingPassDownload,
    trackMainMenuClick,
    trackRailInspectionLoad,
    trackRailInspectionStart,
    trackRailInspectionLvlOneStart,
    trackRailInspectionLvlOneFinish,
    trackRailInspectionNextLevel,
    trackRailInspectionLvlTwoStart,
    trackRailInspectionLvlTwoFinish,
    trackRailInspectionLvlThreeStart,
    trackRailInspectionLvlThreeFinish,
    trackRailInspectionPlayAgain,
    trackViewFinderStart,
    trackViewFinderLoad,
    trackViewFinderLevelOneStart,
    trackViewFinderLevelOneFinish,
    trackViewfinderNextLevel,
    trackViewFinderLevelTwoStart,
    trackViewFinderLevelTwoFinish,
    trackViewFinderLevelThreeStart,
    trackViewFinderLevelThreeFinish,
    trackViewFinderPlayAgain,
    trackAscendLoad,
    trackAscendStart,
    trackAscendFinish,
    trackAscendPlayAgain
  };
};

export default useAnalytics;